import { PencomRoutes } from "@/router/PencomRoutes";

/**
 * Ordered definition of the employer registration onboarding flow.
 * Single source of truth for step order, route, and label.
 * Used by OnboardingStepIndicator and any logic that depends on step position.
 */
export const ONBOARDING_STEP_FLOW = [
    {
        path: PencomRoutes.VERIFY_COMPANY_DETAILS,
        label: "Verify Company Details",
    },
    {
        path: PencomRoutes.EMPLOYER_REG_OTP_VERIFICATION,
        label: "Confirm Company Email",
    },
    {
        path: PencomRoutes.EMPLOYER_REP_DETAILS,
        label: "Contact Person",
    },
    {
        path: PencomRoutes.EMPLOYER_REP_VERIFICATION,
        label: "Confirm Representative Email",
    },
    {
        path: PencomRoutes.ONBOARDING_COMPLETION,
        label: "Completion",
    },
] as const;

export const ONBOARDING_TOTAL_STEPS = ONBOARDING_STEP_FLOW.length;

export type OnboardingStepInfo = {
    step: number;
    total: number;
    label: string;
};

/**
 * Returns the current onboarding step info for the given pathname, or null if not in the flow.
 */
export function getOnboardingStep(pathname: string): OnboardingStepInfo | null {
    const index = ONBOARDING_STEP_FLOW.findIndex((s) => s.path === pathname);
    if (index === -1) return null;
    return {
        step: index + 1,
        total: ONBOARDING_TOTAL_STEPS,
        label: ONBOARDING_STEP_FLOW[index].label,
    };
}

/**
 * Whether the given pathname is part of the step flow (for conditional layout rendering).
 */
export function isOnboardingStepPath(pathname: string): boolean {
    return getOnboardingStep(pathname) !== null;
}
